import { formatPhoneNumber } from './format';

/**
 * Sin nombre, la API de la cartera manda el teléfono pelado («18095550102»): en
 * Clientes se ve con formato («+1 809 555 0102»), como en la fila. PURO.
 */
export function nombreLegible(nombre: string): string {
  return /^\+?\d{7,15}$/.test(nombre.trim()) ? formatPhoneNumber(nombre) : nombre;
}
